'use strict';
import * as $j_dev$002echeleb$002escalamigen$002e$002dForm$0024given$005f$002dForm$005f$002dString$0024 from "./dev.cheleb.scalamigen.-Form$given_-Form_-String$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_Persons$package$$anon$7$$anon$8() {
}
export { $c_Lsamples_Persons$package$$anon$7$$anon$8 as $c_Lsamples_Persons$package$$anon$7$$anon$8 };
$p = $c_Lsamples_Persons$package$$anon$7$$anon$8.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Persons$package$$anon$7$$anon$8;
/** @constructor */
function $h_Lsamples_Persons$package$$anon$7$$anon$8() {
}
export { $h_Lsamples_Persons$package$$anon$7$$anon$8 as $h_Lsamples_Persons$package$$anon$7$$anon$8 };
$h_Lsamples_Persons$package$$anon$7$$anon$8.prototype = $p;
$p.b = (function() {
  return "<function0>";
});
$p.h = (function() {
  return $j_dev$002echeleb$002escalamigen$002e$002dForm$0024given$005f$002dForm$005f$002dString$0024.$m_Ldev_cheleb_scalamigen_Form$given\uff3fForm\uff3fString$();
});
var $d_Lsamples_Persons$package$$anon$7$$anon$8 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Persons$package$$anon$7$$anon$8, "samples.Persons$package$$anon$7$$anon$8", ({
  q6: 1,
  d: 1,
  a: 1,
  f: 1
}));
export { $d_Lsamples_Persons$package$$anon$7$$anon$8 as $d_Lsamples_Persons$package$$anon$7$$anon$8 };
